import moment from "moment";
class employee {
  constructor(id, name, dateStart, dateEnd, file = "") {
    this.id = id;
    this.name = name;
    this.file = file;
    this.dateStart = dateStart
      ? moment.utc(dateStart).format("DD-MM-YYYY")
      : null;
    this.dateEnd = dateEnd ? moment.utc(dateEnd).format("DD-MM-YYYY") : null;
    this.dateStartInput = dateStart
      ? moment.utc(dateStart).format("YYYY-MM-DD")
      : null;
    this.dateEndInput = dateEnd
      ? moment.utc(dateEnd).format("YYYY-MM-DD")
      : null;
  }

  static fromJson(
    { empId, nombre, fecDesde, fecHasta, legajo, file },
    extraFile = "",
  ) {
    const assignedFile = file || legajo || extraFile || "";
    return new employee(empId, nombre, fecDesde, fecHasta, assignedFile);
  }
}
export default employee;
